import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';

const getState = ({ lrwSession }: RootState) => lrwSession;

export const tableState = createSelector(getState, (state) => ({
  pageIndex: state.pageIndex,
  pageSize: state.pageSize,
  sortBy: state.sortBy,
}));

export const filters = createSelector(getState, (state) => state.filters);
